module.exports = __webpack_public_path__ + "img/guide.bbd206b4.png";